import React from "react";
const Footer = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "-20px",
          color: "grey",
        }}
      >
        By&nbsp;
        <a target="_blank" rel="noreferrer" href="https://github.com/sambhavsaxena">
          Sambhav Saxena
        </a>
      </div>
    </div>
  );
};
export default Footer;
